import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { snakeToKebab } from '../../lib/stringHelpers';

const SHIPPING_FEE = 'shipping_fee';

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 5px;
  border-bottom: 1px solid #cccccc;
  font-weight: ${(props) => props.s.fontWeight || 'inherit'};
  &:last-child {
    border-bottom: none;
  }
`;

StyledDiv.defaultProps = {
  s: {},
};

const SummaryDetailsLineItem = ({ language, nameToken, item, config, returnMethod }) => {
  const { style, displayIfZero, useFreeLabel } = config;
  const { key, value, prefix, formatted, label } = item;
  const {
    ['returns.general.free_label']: freeLabel,
    [`returns.step_3.${key}_label`]: genericLabel,
    [`returns.step_3.${nameToken}.${key}.label`]: tokenizedLabel,
    ['returns.step_3.return_method_label']: returnMethodLabel,
    [`returns.step_3.${returnMethod}`]: returnMethodKeyLabel,
  } = language;
  const labelContent =
    key === SHIPPING_FEE
      ? `${returnMethodLabel} ${returnMethodKeyLabel}`
      : label || tokenizedLabel || genericLabel || '';
  const baseClass = `return-summary-${snakeToKebab(key)}`;
  const hasValue = value > 0;

  if (!hasValue && !displayIfZero) return null;
  if (key === SHIPPING_FEE && !returnMethod) return null;

  return (
    <StyledDiv
      className={classNames(`${baseClass}-container`, {
        ['has-value']: hasValue,
        ['no-value']: !hasValue,
      })}
      s={style}
      tabIndex="0"
    >
      <span className={`${baseClass}-key`} dangerouslySetInnerHTML={{ __html: labelContent }} />
      <span className={`${baseClass}-value`}>
        {!hasValue && useFreeLabel ? freeLabel : `${prefix}${formatted}`}
      </span>
    </StyledDiv>
  );
};

SummaryDetailsLineItem.defaultProps = {
  nameToken: '',
};

SummaryDetailsLineItem.propTypes = {
  language: PropTypes.object.isRequired,
  item: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.number,
    prefix: PropTypes.string,
    formatted: PropTypes.string,
  }).isRequired,
  config: PropTypes.shape({
    key: PropTypes.string,
    style: PropTypes.object,
    displayIfZero: PropTypes.bool,
  }).isRequired,
  returnMethod: PropTypes.string.isRequired,
  nameToken: PropTypes.string,
};

export default SummaryDetailsLineItem;
